import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { defaultTo, path } from 'ramda';

import { toCurrency, getDiscountFromLineItems } from '../../../util/helpers';
import { isNilOrEmpty } from '../../../util/redux';
import Card from '../../../components/Card';
import { apiGetPayment } from '../../../api/user';
import { routes } from '../../../routes';

const mapState = ({ user }) => ({ user });

class Receipt extends Component {
  state = {
    loading: true,
    transaction: {},
  };

  propTypes = {
    user: PropTypes.object,
  };

  componentDidMount() {
    const { match } = this.props;
    const selectedPaymentId = Number(match.params.id);
    apiGetPayment(selectedPaymentId)
      .then(({ data }) => this.setState({ loading: false, transaction: data }))
      .then(() => this.setState({ loading: false }))
      .then(() => window.scrollTo(0, 0));
  }

  renderRow = (label, value) => (
    <div>
      <span className="font-weight-bold">{label}</span>: {value}
    </div>
  );

  render() {
    if (this.state.loading) return <noscript />;
    const { user } = this.props;
    const { transaction } = this.state;
    const discount = getDiscountFromLineItems(transaction.lineItems);

    return (
      <div className="row">
        <div className="col-md-6 offset-md-3">
          <Link to={routes.payments.root} className="d-block d-print-none mb-4">
            &lt; Back to all Payments
          </Link>
          <Card>
            <Card.Header>Receipt from Sage Financial Solutions</Card.Header>
            <Card.Body>
              {this.renderRow('For', `${user.firstName} ${user.lastName}`)}
              {this.renderRow('On', moment(transaction.createdAt).format('MM/DD/YYYY'))}
              {this.renderRow('Total', toCurrency(transaction.amount))}

              <h6 className="mt-4">Line Items:</h6>
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {transaction.lineItems.map((payment) => {
                    const extra = defaultTo(path(['extra', 'due'], payment), path(['extra', 'year'], payment));

                    return (
                      <tr key={payment.id}>
                        <td>{`${payment.name}${extra ? ` (${extra})` : ''}`}</td>
                        <td>{toCurrency(payment.finalPrice)}</td>
                      </tr>
                    );
                  })}
                  {!isNilOrEmpty(discount) && (
                    <tr>
                      <td>Discount Code: {discount.code}</td>
                      <td>{discount.percentage ? `-${discount.amount}%` : `-${toCurrency(discount.amount)}`}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
}
export default withRouter(connect(mapState)(Receipt));
